import React from "react";
import { Link } from "react-router-dom";

const DoctorCards = ({id,fname,lname,address,type,city,country,image,rating}) => {

  const elements = [];

  for (let i = 1; i <= rating; i++) {
    elements.push(<i class="icon_star voted"></i>);
  }

  return (
    <>
		<>
      <div class="col-lg-4 col-md-6">
        <div class="box_list home">
          {/* <a href="#0" data-bs-toggle="tooltip" data-bs-placement="top" title="Add to wishlist" class="wish_bt"></a> */}
          <figure>
            <Link to={'/details?id='+id}>
            <img src={image} alt="not found" style={{width: "100%"}}/>
            </Link>
            <div class="preview">
              <span>Read more</span>
            </div>
          </figure>
          <div class="wrapper">
            <small>{type}</small>
            <h3>{fname}&nbsp;{lname}</h3>
            <small className="text-black">{address} | {city} | {country}</small>
            {/* <span class="rating">
              {rating === 0 ?
              <i class="icon_star"></i> :
            elements }<small>({rating})</small>
            </span> */}
            <a
              href="#0"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Badge Level"
              class="badge_list_1"
            >
              <img src="img/badges/badge_6.svg" width="15" height="15" alt="" />
            </a>
          </div>
        </div>
      </div>
	  </>
    </>
  );
};

export default DoctorCards;
